import React from 'react';
import SelectBox from 'devextreme-react/select-box';

export default ({ items, value, handleChange, displayExpr, valueExpr, searchEnabled, showDataBeforeSearch }) => {

    let valRef = valueExpr ? valueExpr : 'id';
    let displayRef = displayExpr ? displayExpr : 'label';
    let searchEnabledRef = searchEnabled ? searchEnabled : false;
    let showDataBeforeSearchRef = showDataBeforeSearch ? showDataBeforeSearch : false;
    return (
        <SelectBox
            items={items}
            value={value}
            displayExpr={displayRef}
            searchEnabled={searchEnabledRef}
            showDataBeforeSearch={showDataBeforeSearchRef}
            valueExpr={valRef}
            onValueChanged={({ component }) => {
                handleChange(component.option('selectedItem'));
            }}
        />
    )
}